export enum FilterFieldEnum{
    Products = 1,
    PostalCode = 2,
    Segment = 3,
    Tags = 4
  }
  